export default __webpack_public_path__ + "static/media/family_white.90d704f0.svg";